import { BusinessUnit } from "@/types/BusinessUnit";
import { Company } from "@/types/Company";
import { Role } from "@/types/Role";

export function getPermissions(target: BusinessUnit | Company | undefined, roles:Role[] | undefined): string[]
{
    if(!roles || !target){
         return [];
    }

    const allPermissions = target.roles?.flatMap((roleKey)=>{
        
        return roles.find((role) => role.key == roleKey)?.permissions ?? [];
    })

    return Array.from(new Set(allPermissions ?? []));
}